// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".publicDownloadBtn[data-v-4e8143de]{color:#0455a7;font-size:14px}", ""]);
// Exports
module.exports = exports;
